<div *ngIf="form && this.attendanceTime" editorType="tiny">

  <form [formGroup]="form">
    <div class="column">
      <dx-text-area [readOnly]="true" formField formControlName="workerName" [label]="'entity.attendanceEntry.workerName' | translate"></dx-text-area>
      <dx-date-box formField required type="datetime" formControlName="entryIn" [label]="'entity.attendanceEntry.entryIn' | translate"></dx-date-box>
      <dx-date-box formField type="datetime" formControlName="entryOut" [label]="'entity.attendanceEntry.entryOut' | translate"></dx-date-box>
      <gs-time-span-field [inputTimespan]="this.attendanceTime"
        [label]="'entity.attendanceEntry.attendanceTime' | translate" required formField
        formControlName="attendanceTime" />
    </div>
  </form>

  <div class="mt-3 text-right">
    <dx-button [disabled]="!form!.valid || form!.pristine" (onClick)="submit()" [type]="'default'" [icon]="'done'"
      [text]="'common.save' | translate | ucfirst"></dx-button>
  </div>

</div>